import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import ExclusiveContainer from '../components/ExclusiveContainer'

export default function N25_11_05() {
  return (
    <NoteContainer date={'05/11/2025'} version="20.19.0">
      <VStack w="full">
        <ModuleContainer moduleName="SCHEDULES">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Lógica de entradas na fila isoladas</TaskTitle>
                <TaskBreadcrumb>Agendas/ Agenda/ Fila de espera</TaskBreadcrumb>
                <TaskDescription>
                  Agora cada entrada na fila funciona de maneira independente, contendo auxílios visuais e informações
                  referentes somente àquela entrada na fila e não mais ao usuário como um todo. Dessa forma, facilitando
                  o controle de entradas múltiplas de usuários na mesma fila.
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Correções de nomenclaturas</TaskTitle>
                <TaskBreadcrumb>Agendas/ Agenda/ Agendamentos</TaskBreadcrumb>
                <TaskDescription>Correção de nomenclaturas nos cabeçalhos e na janela de filtros</TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Ajuste no acordeão da fila de espera</TaskTitle>
                <TaskBreadcrumb>Agendas/ Agenda/ Fila de espera</TaskBreadcrumb>
                <TaskDescription>Agora o acordeão de cada fila pode ser aberto e fechado com o clique</TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção nos filtros rápidos do agendamento</TaskTitle>
                <TaskBreadcrumb>Agendas/ Agenda/ Agendamentos</TaskBreadcrumb>
                <TaskDescription>
                  Correção da filtragem pela barra de filtragem rápida da página de agendamentos
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ModuleContainer moduleName="VULNERABILITY_ALERTS">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Redirecionamento quando acessado direto o perfil do alerta sem estar logado</TaskTitle>
                <TaskBreadcrumb>Alertas/ Alerta</TaskBreadcrumb>
                <TaskDescription>
                  Agora, quando o alerta é acessado direto pelo seu perfil e o(a) usuário(a) não está autenticado na
                  plataforma, é apresentado o acesso rápido ao login e posteriormente, o retorno à página em questão
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ModuleContainer moduleName="APP_CITIZEN">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <ExclusiveContainer category="ADJUSTMENTS" institutions={['teste', 'treinamento', 'agsus']}>
                <VStack w="full">
                  <Box>
                    <TaskTitle>Adicionada informações na consulta do holerite</TaskTitle>
                    <TaskBreadcrumb>Perfil/ Consultar holerite</TaskBreadcrumb>
                    <TaskDescription>
                      Agora, na janela de busca do holerite, é apresentado os filtros pesquisado, assim como mensagens
                      para erros específicos, facilitando assim a compreensão para o usuário
                    </TaskDescription>
                  </Box>
                  <Box>
                    <TaskTitle>Acesso rápido ao PDF</TaskTitle>
                    <TaskBreadcrumb>Perfil/ Consultar holerite</TaskBreadcrumb>
                    <TaskDescription>
                      Agora, ao acessar a janela de consulta, já será informado se o arquivo está disponível para
                      visualização ou não, e se não tiver, o porquê não é possível acessá-lo
                    </TaskDescription>
                  </Box>
                </VStack>
              </ExclusiveContainer>
              <Box>
                <TaskTitle>Adicionado informações sobre os acompanhantes no calendário</TaskTitle>
                <TaskBreadcrumb>Perfil/ Calendário</TaskBreadcrumb>
                <TaskDescription>
                  Agora, nos agendamentos do calendário, aparece o nome, se houver, do(a) acompanhante
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ModuleContainer moduleName="REGULATION">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle>Auxílios visuais para saber se o cidadão já está em uma fila de espera</TaskTitle>
                <TaskBreadcrumb>Regulação/ Solicitações/ Fila de espera</TaskBreadcrumb>
                <TaskDescription>
                  Agora, ao abrir a janela para adicionar o cidadão na fila, já irá aparecer as informações de quais
                  filas e as respectivas posições, o usuário se encontra
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Auxílios visuais para saber se o cidadão já está na fila selecionada</TaskTitle>
                <TaskBreadcrumb>Regulação/ Solicitações/ Fila de espera</TaskBreadcrumb>
                <TaskDescription>
                  Agora, ao abrir a janela para adicionar o cidadão na fila, ao selecionar um serviço, se ele já estiver
                  na fila do serviço selecionado, irá aparecer um alerta informativo, evitando entradas duplicadas
                  desnecessárias na fila.
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
